import type {
    ICalculatorSettings,
    IContact,
    IEservices,
    IFooterAddress,
    IFooterColumn,
    IHeaderImageMetaData,
    IL10nUrl,
    ILanguage,
    IOrders,
    ISettings,
    ITeaser,
} from '../../api/domain';
import { getImageUrl as mockGetImageUrl } from '../../api/services/mock/mock-settings-api-service';
import { getImageUrl as actualGetImageUrl } from '../../api/services/settings/settings-api-service';
import type { IRootState } from '../root-reducer';
import type { IProductSettings } from '../../api/domain/settings/product-settings';

export const isSettingsInitialized = (state: IRootState) => state.settingsApi.initialized;

export const showTeasers = (state: IRootState) => {
    const show = state.settingsApi.settings?.showTeasers;

    return show !== undefined ? show : true;
};

export const getTeasers = (state: IRootState): ITeaser[] => state?.settingsApi?.settings?.teasers || [];

export const getFooterAddress = (state: IRootState): IFooterAddress[] => state?.settingsApi?.settings?.footer?.address || [];

export const getFooterColumns = (state: IRootState): IFooterColumn[] => state?.settingsApi?.settings?.footer?.columns || [];

export const getHeaderPictures = (state: IRootState): IHeaderImageMetaData[] => state?.settingsApi?.settings?.header?.pictures || [];

export const getUseBankLogoExternalUrl = (state: IRootState): boolean => state?.settingsApi?.settings?.header?.useBankLogoExternalUrl || false;

export const getBankLogoExternalUrl = (state: IRootState): IL10nUrl[] => state?.settingsApi?.settings?.header?.bankLogoExternalUrl || [];

export const getEServicesSettings = (state: IRootState): IEservices | undefined => state?.settingsApi?.settings?.eservices;

export const getCalculators = (state: IRootState): ICalculatorSettings | undefined => state.settingsApi?.settings?.calculator;

/** @deprecated TODO: Should also be removed in customization module */
/*export const isLogoOverHeader = (state: IRootState): boolean => {
    const overlapLogo = state?.settingsApi?.settings?.header?.overlapLogo;

    return overlapLogo !== undefined ? overlapLogo : true;
};*/

export const getSettings = (state: IRootState): ISettings | undefined => state?.settingsApi?.settings;

export const getProductSettings = (state: IRootState): IProductSettings | undefined => state?.settingsApi?.settings?.productSettings;

export const getContact = (state: IRootState): IContact | undefined => state?.settingsApi?.settings?.contact;

export const getLanguages = (state: IRootState): ILanguage[] => state?.settingsApi?.languages || [];

export const getActiveLanguages = (state: IRootState): ILanguage[] => getLanguages(state).filter(({ active }) => active);

export const getProducts = (state: IRootState) => state.settingsApi.products;

export const isFetchingProducts = (state: IRootState) => state.settingsApi.isFetchingProducts;

export const getRelationshipTypes = (state: IRootState) => state?.settingsApi?.settings?.eservices?.powerOfAttorney.relationshipTypes || [];

export const getOrdersSettings = (state: IRootState): IOrders | undefined => state.settingsApi.settings?.eservices.orders;

export const isInternationalPhoneFormatEnabled = (state: IRootState): boolean => !!state?.settingsApi?.settings?.contact?.useInternationalPhoneFormat;

export const getHeaderImageMetaData = (state: IRootState): IHeaderImageMetaData | undefined => state?.settingsApi?.headerImageMetaData;

export const getProductsNotificationSettings = (state: IRootState) => state?.settingsApi?.settings?.productNotification;

export const getEbankingIFrameEnabled = (state: IRootState): boolean => !!state?.settingsApi?.settings?.eBankingPortal?.eBankingIFrameEnabled;

/**
 * To enable image endpoint mocking when running the portal with `yarn mock` we have to provide a mock implementation when REACT_APP_MOCK is set.
 * In virtually all other cases this is done in configure-store.ts by swapping the whole service with a mock implementation.
 * Since getImageUrl() lives outside the service and is directly used by components, not just via sagas, we have to put the mock switch somewhere else - and chose to do it here
 */
export const getImageUrl = process.env.REACT_APP_MOCK ? mockGetImageUrl : actualGetImageUrl;
